// extracted by mini-css-extract-plugin
export default {"_wrapper":"PatientsTable__wrapper__M0ySz","_table_head":"PatientsTable__table_head__Z3SM9"};